export default __webpack_public_path__ + "static/media/donation_helping.82e11190.png";